export function asArray(value) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data?.data)) return value.data.data;
  if (Array.isArray(value?.data)) return value.data;
  return [];
}

export function unwrapPage(payload) {
  const page = payload?.data && !Array.isArray(payload.data) ? payload.data : payload || {};
  const rows = Array.isArray(page.data)
    ? page.data
    : Array.isArray(page)
      ? page
      : Array.isArray(payload)
        ? payload
        : [];
  return {
    data: rows,
    total: page.total || rows.length,
    page: page.page || 1,
    pageSize: page.pageSize || page.limit || rows.length || 20,
    hasNext: page.hasNext,
  };
}

export function toSelectOption(item) {
  const entity = item?.entity || item || {};
  return {
    ...entity,
    id: entity.id,
    label: entity.label || entity.name,
    name: entity.label || entity.name,
    value: entity.id,
  };
}

export function parseApiError(error, translate) {
  if (error?.statusCode === "440") {
    window.location.replace("/login");
    return translate ? translate("sessionExpired") : "sessionExpired";
  }
  const raw = error?.message || error?.statusText || "";
  if (typeof raw === "string" && raw.includes(":")) {
    const parts = raw.split(":");
    const msg = (parts[1] || parts[0]).replace(")", "").split("&#")[0].trim();
    return translate ? translate(msg) : msg;
  }
  return translate ? translate("somethingWentWrong") : "somethingWentWrong";
}

export function toQuery(params = {}) {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");
}
